import { useState } from "react";
// Icons
import SmartSelector from "@Layouts/components/InputComponents/SmartSelector";

type RatingSelectProps = Readonly<{
	onRatingChange: (value: number[]) => void;
	error?: boolean;
	loading?: boolean;
	className?: string;
	maxStars?: number;
}>;

interface IOption {
	label: string;
	value: number;
}

const createOptions = (maxStars: number): IOption[] => {
	return Array.from({ length: maxStars }, (_, i) => ({
		label: `${maxStars - i} Star${maxStars - i > 1 ? "s" : ""}`,
		value: maxStars - i,
	}));
};

export default function RatingSelect(props: RatingSelectProps) {
	const [selectedValues, setSelectedValues] = useState<IOption[]>([]);

	/********************************************* HANDLERS ************************************************/
	const handleChange = (values: IOption[]) => {
		setSelectedValues(values);
		props.onRatingChange(values.map((value) => value.value));
	};

	const options = createOptions(props.maxStars ?? 5);

	return (
		<SmartSelector
			// Data
			options={options}
			selected={selectedValues}
			// Options
			multiple
			multipleSelectAll
			showBy={"label"}
			selectBy={"value"}
			tagsVariant={"text"}
			inputProps={{ placeholder: "Ratings", sx: { width: "160px" } }}
			popperProps={{ className: "!z-[1350]" } as object}
			listBoxProps={{
				sx: { maxHeight: "220px" },
			}}
			// Callback
			onChangeAction={(value) => handleChange(value as IOption[])}
		/>
	);
}
